import React from 'react'
import MobileSidebarLink from '../components/account/mobileSidebarLink'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'

const MobileSidebar = () => {
  return (
    <div>
      <Navbar />
      <div className="md:mx-16">
        <MobileSidebarLink />
      </div>
      <Footer/>
    </div>
  )
}

export default MobileSidebar